import {
  getOrdersClient,
  BidStatus,
  makeAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { OrderResponseDto } from '@b-stock/order-api-client'
import { OrdersApiControllerFindAllSubjectTypeEnum } from '@b-stock/order-api-client'

const getBuyerOrderByListingId = async (
  accessToken: string,
  listingId: string,
  bidState?: BidStatus
): Promise<OrderResponseDto | null> => {
  if (bidState && bidState !== BidStatus.WON) return null

  const ordersClient = getOrdersClient()

  const { data } = await ordersClient.ordersApiControllerFindAll(
    {
      listingId,
      orderType: ['LISTING'],
      subjectType: [OrdersApiControllerFindAllSubjectTypeEnum.Buyer],
    },
    buildAxiosRequestConfig({ accessToken })
  )

  const orders = data.orders
  if (orders.length > 0) {
    // orders[0] is guaranteed to exist because we checked length > 0
    return orders[0] ?? null
  }

  return null
}

const buyerOrderByListingIdQuery = makeAuthenticatedQuery(
  'buyerOrder',
  getBuyerOrderByListingId
)

export default buyerOrderByListingIdQuery
